import { Checkbox } from "src/primitives/Checkbox";
import { cn } from "src/shadcn/lib/utils";

interface TreeCheckboxProps {
  checked: boolean;
  indeterminate: boolean;
  disabled: boolean;
  onChange: () => void;
}

export const TreeCheckbox = ({
  checked,
  indeterminate,
  disabled,
  onChange,
}: TreeCheckboxProps) => (
  <Checkbox
    aria-label="Select node"
    checked={indeterminate ? "indeterminate" : checked}
    className={cn("mr-1.5 shrink-0", disabled && "opacity-50")}
    disabled={disabled}
    onClick={e => e.stopPropagation()}
    onCheckedChange={onChange}
  />
);
